import ForgetPwd from '../Componant/Pages/Auth/ForgetPwd';
import LoginSample from '../Componant/Pages/Auth/Login';
import LoginOne from '../Componant/Pages/Auth/LoginOne';
import LoginSweetalert from '../Componant/Pages/Auth/LoginSweetalert';
import LoginTooltip from '../Componant/Pages/Auth/LoginTooltip';
import LoginTwo from '../Componant/Pages/Auth/LoginTwo';
import LoginValidation from '../Componant/Pages/Auth/LoginValidation';
import Maintenance from '../Componant/Pages/Auth/Maintenance';
import RegisterBgImg from '../Componant/Pages/Auth/RegisterBgImg';
import RegisterBgImg2 from '../Componant/Pages/Auth/RegisterBgImg2';
import RegisterSimple from '../Componant/Pages/Auth/RegisterSimple';
import ResetPassword from '../Componant/Pages/Auth/ResetPassword';
import UnlockUser from '../Componant/Pages/Auth/UnlockUser';
import ComingSimple from '../Componant/Pages/CommingSoon/ComingSimple';
import ComingSoonbgImg from '../Componant/Pages/CommingSoon/ComingSoonbgImg';
import ComingwithbgVideo from '../Componant/Pages/CommingSoon/ComingwithbgVideo';
import Errorpage1 from '../Componant/Pages/Error/Error_page1';
import Errorpage2 from '../Componant/Pages/Error/Error_page2';
import Errorpage3 from '../Componant/Pages/Error/Error_page3';
import Errorpage4 from '../Componant/Pages/Error/Error_page4';
import Errorpage5 from '../Componant/Pages/Error/Error_page5';

export const AUTH_ROUTES = [
  // Error Pages
  { path: `${process.env.PUBLIC_URL}/others/error-page-1`, element: <Errorpage1 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-2`, element: <Errorpage2 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-3`, element: <Errorpage3 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-4`, element: <Errorpage4 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-5`, element: <Errorpage5 /> },

  // Auth Pages
  { path: `${process.env.PUBLIC_URL}/auth/login`, element: <LoginSample /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-bg-img`, element: <LoginOne /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-bg-img2`, element: <LoginTwo /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-bs-validation`, element: <LoginValidation /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-bs-tt-validation`, element: <LoginTooltip /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-sa-validation`, element: <LoginSweetalert /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up`, element: <RegisterSimple /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up-one`, element: <RegisterBgImg /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up-two`, element: <RegisterBgImg2 /> },
  { path: `${process.env.PUBLIC_URL}/auth/unlock`, element: <UnlockUser /> },
  { path: `${process.env.PUBLIC_URL}/auth/forget-password`, element: <ForgetPwd /> },
  { path: `${process.env.PUBLIC_URL}/auth/reset-password`, element: <ResetPassword /> },
  { path: `${process.env.PUBLIC_URL}/auth/maintenance`, element: <Maintenance /> },

  // Coming Soon
  { path: `${process.env.PUBLIC_URL}/coming-soon/coming-soon`, element: <ComingSimple /> },
  { path: `${process.env.PUBLIC_URL}/coming-soon/coming-soon-bg-video`, element: <ComingwithbgVideo /> },
  { path: `${process.env.PUBLIC_URL}/coming-soon/coming-soon-bg-img`, element: <ComingSoonbgImg /> },
];
